import React from 'react';
import './AlertMessage.scss';
function AlertMessage(_a) {
    var message = _a.message, children = _a.children, id = _a.id;
    return (React.createElement("div", { className: "elmo-alert__message", "data-testid": "elmo-alert-message-".concat(id || 'default') }, message || children));
}
export default AlertMessage;
